var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u533A\u575724*24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u81F3\\u4FE1\\u94FE\\u6D4F\\u89C8\\u5668v1.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875\\u5907\\u4EFD-2",
    transform: "translate(-60.000000, -653.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(36.000000, 629.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u533A\\u575724*24",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(3.000000, 3.000000)",
    fill: "#0052D9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2000112,7.2000112 L0,7.2000112 L0,0 L7.2000112,0 L7.2000112,7.2000112 Z M1.20000498,6.00000622 L6.00000622,6.00000622 L6.00000622,1.20000498 L1.20000498,1.20000498 L1.20000498,6.00000622 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "6.00000622 2.99999378 10.8000075 2.99999378 10.8000075 4.19999876 6.00000622 4.19999876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00000622,2.99999378 L10.8000075,2.99999378 L10.8000075,4.19999876 L6.00000622,4.19999876 L6.00000622,2.99999378 Z M3.59999627,6.00000622 L4.80000124,6.00000622 L4.80000124,10.8000075 L3.59999627,10.8000075 L3.59999627,6.00000622 Z M13.1999988,7.19999253 L14.3999851,7.19999253 L14.3999851,10.7999888 L13.1999988,10.7999888 L13.1999988,7.19999253 Z M7.79999502,12.0000124 L10.8000075,12.0000124 L10.8000075,13.1999988 L7.79999502,13.1999988 L7.79999502,12.0000124 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8.39999751 L9.60002115,8.39999751 L9.60002115,0 L18,0 L18,3.12343641 L16.799995,3.12343641 L16.799995,1.20000498 L10.8000075,1.20000498 L10.8000075,7.19999253 L16.799995,7.19999253 L16.799995,5.96015291 L18,5.96015291 L18,8.39999751 Z M8.39999751,18 L0,18 L0,9.60002115 L8.39999751,9.60002115 L8.39999751,18 Z M1.20000498,16.799995 L7.19999253,16.799995 L7.19999253,10.8000075 L1.20000498,10.8000075 L1.20000498,16.799995 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8000012,18 C12.6781349,18 11.6234312,17.5631441 10.8301541,16.769867 C10.036877,15.9765899 9.60002115,14.9218676 9.60002115,13.8000012 C9.60002115,12.6781349 10.036877,11.6234312 10.8301541,10.8301541 C11.6234312,10.036877 12.6781349,9.60002115 13.8000012,9.60002115 C14.9218676,9.60002115 15.9765899,10.036877 16.769867,10.8301541 C17.5631441,11.6234312 18,12.6781349 18,13.8000012 C18,14.9218676 17.5631441,15.9765899 16.769867,16.769867 C15.9765899,17.5631441 14.9218489,18 13.8000012,18 Z M13.8000075,10.8000075 C12.1457991,10.8000075 10.8000075,12.1457991 10.8000075,13.8000075 C10.8000075,15.4542034 12.1457991,16.8000075 13.8000075,16.8000075 C15.4542034,16.8000075 16.8000075,15.4542034 16.8000075,13.8000075 C16.8000075,12.1457991 15.4542034,10.8000075 13.8000075,10.8000075 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8000012,18 C12.6781349,18 11.6234312,17.5631441 10.8301541,16.769867 C10.036877,15.9765899 9.60002115,14.9218676 9.60002115,13.8000012 C9.60002115,12.6781349 10.036877,11.6234312 10.8301541,10.8301541 C11.6234312,10.036877 12.6781349,9.60002115 13.8000012,9.60002115 C14.9218676,9.60002115 15.9765899,10.036877 16.769867,10.8301541 C17.5631441,11.6234312 18,12.6781349 18,13.8000012 C18,14.9218676 17.5631441,15.9765899 16.769867,16.769867 C15.9765899,17.5631441 14.9218489,18 13.8000012,18 Z M13.8000075,10.8000075 C12.1457991,10.8000075 10.8000075,12.1457991 10.8000075,13.8000075 C10.8000075,15.4542034 12.1457991,16.8000075 13.8000075,16.8000075 C15.4542034,16.8000075 16.8000075,15.4542034 16.8000075,13.8000075 C16.8000075,12.1457991 15.4542034,10.8000075 13.8000075,10.8000075 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlock);
export default __webpack_public_path__ + "static/media/icon-block.836241086cf8d4b87deb255476d290fe.svg";
export { ForwardRef as ReactComponent };